/// background color changing with scroll function
gsap.fromTo(
  ".parallax-section",
  {
    backgroundColor: "#fffbf6",
    // 14/10/2024
    // backgroundColor: "#FEEDF9",
  },
  {
    backgroundColor: "#fbd1ff",
    ease: "none",
    scrollTrigger: {
      trigger: ".parallax-section",

      start: "+=15% 30%",
      end: "60% 40%",
      markers: false,
      scrub: true,
    },
  }
);
